import { bl_mrp_process_template_import_file_helper_RowClass } from "../../dbschema/bl_mrp_process_template_import_file_helper.model";
import { BaseContainerModel } from "../base-container.model";

export class ProcessTemplateImportFileHelperContainerModel extends BaseContainerModel {
    bl_mrp_process_template_import_file_helper: bl_mrp_process_template_import_file_helper_RowClass = new bl_mrp_process_template_import_file_helper_RowClass();
}